export default {
  debug: true,
    testing: true,
  fred: true
};
